<template>
  <div class="card_list">
    <title-bar-back :title="$route.query.cardName" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="!queryCardVoucherUserByPage.hasNextPage"
        finished-text="我已经到底啦～"
        @load="onLoad"
      >
        <div
          v-for="(item, index) in queryCardVoucherUserByPage.rows"
          :key="index"
          :class="{ item_list_top: index === 0 }"
          class="list_item"
        >
          <!-- <img src="@/assets/mine/bg_week@2x.png" alt="" class="bg_img" /> -->
          <img :src="item.baseImg" alt="" class="bg_img" />
          <div class="card_item">
            <div
              class="font16 font_weight500 line_height_22 colof text_left item_name"
            >
              {{ item.voucherName }}
            </div>
            <div
              class="font12 font_weight400 line_height_16 colof87 text_left item_date"
            >
              有效期：{{
                item.effectType === 1
                  ? item.expireStartTime.substring(0, 10) +
                    "-" +
                    item.expireEndTime.substring(0, 10)
                  : "永久使用"
              }}
            </div>
            <div
              class="font12 font_weight400 line_height_16 text_left colof87 item_id"
            >
              订单号：{{ item.buyOrderSn }}
            </div>
            <div class="item_btn">
              <div
                class="btn_item font12 font_weight400 line_height_22 text_left colo287"
                @click="showPoster(item)"
              >
                转增
              </div>
              <div
                class="btn_item font12 font_weight400 line_height_22 text_left colo287 btn_mr"
                @click="exchange(item)"
              >
                兑换
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <div class="font12 font_weight400 colo087 bottom_all" @click="lookUseList">
      <span class="look">查看使用记录</span>
      <img src="@/assets/common/icon_right_go@2x.png" alt="" class="go_right" />
    </div>
    <exchange
      :showExchange="showExchange"
      @clickBg="clickBg"
      @useCard="useCard"
      :chooseItem="chooseItem"
    />
    <poster
      v-if="show"
      :show="show"
      :posterItem="posterItem"
      @closePoster="closePoster"
      @openShare="openShare"
    />
    <share-mask
      v-if="showShareMask"
      :showShareMask="showShareMask"
      @hideMask="hideMask"
    />
  </div>
</template>

<script>
import NativeShare from "nativeshare";
import TitleBarBack from "@/components/TitleBarBack";
const Exchange = () =>
  import("./components/Exchange").then(m => m.default || m);
const Poster = () => import("./components/Poster").then(m => m.default || m);
const ShareMask = () =>
  import("./components/ShareMask").then(m => m.default || m);
export default {
  name: "CardVoucher",
  components: {
    TitleBarBack,
    Exchange,
    Poster,
    ShareMask
  },
  data() {
    return {
      loading: false,
      packageListBg: [1, 2, 3, 4],
      showExchange: false,
      show: false,
      showShareMask: false,
      chooseItem: {},
      posterItem: {}
    };
  },
  computed: {
    queryCardVoucherUserByPage() {
      return this.$store.getters.queryCardVoucherUserByPage;
    },
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    }
  },
  created() {
    this.getData();
    this.getUserData();
  },
  methods: {
    back() {
      this.$router.back();
    },
    getData(pageNo = 1) {
      // queryCardVoucherUserByPage
      const params = {
        pageNo: pageNo,
        pageSize: 20,
        packageId: this.$route.query.packageId
      };
      this.$store
        .dispatch("mine/queryCardVoucherUserByPage", { params })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {});
    },
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    onRefresh() {
      this.getData();
      this.getUserData();
    },
    onLoad() {
      this.loading = false;
      if (
        this.queryCardVoucherUserByPage.hasNextPage &&
        this.queryCardVoucherUserByPage.pageNo <=
          this.queryCardVoucherUserByPage.pageCount
      ) {
        this.loading = true;
        const pageIndex = this.queryCardVoucherUserByPage.pageNo + 1;
        this.getData(pageIndex);
        // console.log("上拉完毕");
      }
    },
    goLook() {
      this.$router.push("/user/milkrecord?status=0");
    },
    lookUseList() {
      this.$router.push("/mine/uselist");
    },
    exchange(item) {
      this.chooseItem = item;
      this.showExchange = true;
    },
    clickBg() {
      this.showExchange = false;
    },
    closePoster() {
      this.show = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    useCard(id) {
      this.$router.push({
        path: "/order/exchangemilkorder",
        query: {
          id
        }
      });
    },
    showPoster(item) {
      this.posterItem = item;
      this.show = true;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    openShare() {
      // const host = window.location.host;
      // const icon = `https://${host}/logo.png`;
      // console.log(typeof NativeShare);
      if (typeof NativeShare !== "undefined") {
        if (this.isWechatBrowser()) {
          this.show = false;
          this.showShareMask = true;
        } else {
          this.$toast("需要在微信浏览器分享哦！");
        }
        // } else {
        //   console.log(333);
        //   const link = `${window.location.href}&slug=${this.slug}`;
        //   var nativeShare = new NativeShare({
        //     syncDescToTag: false,
        //     syncIconToTag: false,
        //     syncTitleToTag: false
        //   });
        //   nativeShare.setShareData({
        //     icon: icon,
        //     link: link,
        //     title: this.posterItem.voucherName,
        //     desc: "dedede",
        //     from: this.getSimpleUserInfo.username
        //   });
        //   console.log(nativeShare, 444);
        //   try {
        //     nativeShare.call();
        //   } catch (err) {
        //     // console.log(err)
        //     // this.$toast(err.message)
        //     // 如果不支持，你可以在这里做降级处理
        //   }
        // }
      }
      // const appId = 'wxd9415fe8da6085d7'
      // const timestamp = dayjs().valueOf()
      // const nonceStr = uuidv1()
      // wx.config({
      //   debug: false,
      //   appId: appId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
      //   timestamp: timestamp, // 必填，生成签名的时间戳
      //   nonceStr: nonceStr, // 必填，生成签名的随机串
      //   signature: signature,// 必填，签名，见附录1
      //   //需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
      //   jsApiList: [
      //     'onMenuShareAppMessage',
      //     'onMenuShareTimeline',
      //     'onMenuShareQQ',
      //     'onMenuShareQZone'
      //   ]
      // })
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.card_list {
  .item_list_top {
    margin-top: 12px;
  }
  .list_item {
    font-size: 0;
    position: relative;
    margin: 12px 15px;
    .bg_img {
      width: 100%;
      max-height: 140px;
    }
    .card_item {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding-left: 140px;
      .item_name {
        margin-top: 12px;
      }
      .item_date {
        margin-top: 5px;
      }
      .item_id {
        margin-top: 2px;
      }
      .item_btn {
        display: flex;
        justify-content: flex-end;
        margin: 20px 27px 0 0;
        .btn_item {
          background: #ffffff;
          border-radius: 11px;
          padding: 0 20px;
        }
        .btn_mr {
          margin-left: 10px;
        }
      }
    }
  }
  .bottom_all {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    background: #fff;
    height: 48px;
    .look {
      line-height: 24px;
      vertical-align: middle;
      display: inline-block;
      margin-top: 14px;
    }
    .go_right {
      vertical-align: middle;
      margin-top: 10px;
      width: 24px;
    }
  }
}
</style>
